(() => {
  if (customElements.get('hero-banner')) {
    return;
  }

  class HeroBanner extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      document.addEventListener(
        'DOMContentLoaded',
        this.handleOnPageLoad.bind(this),
      );

      ['load', 'resize'].forEach((eventName) => {
        window.addEventListener(
          eventName,
          this.setPromoHeightVariable.bind(this),
        );
      });
    }

    handleOnPageLoad() {
      this.classList.add('is-loaded');
    }

    setPromoHeightVariable() {
      const promoBar = document.querySelector('[data-promo-bar]');
      let offset = promoBar.offsetHeight;

      if (!promoBar) {
        let offset = 0;
      }

      this.style.setProperty('--promo-bar-height', `${offset}px`);
    }
  }

  customElements.define('hero-banner', HeroBanner);
})();
